// Wholly below the screen again, scrolled back up past: reset there, out of sight, it plays again on the way down. Not when it leaves through the top: scrolled back up to, it is as it was left.
export function whenBelow(element, callback) {
	new IntersectionObserver(([entry]) => {
		if (!entry.isIntersecting && entry.boundingClientRect.top > 0) {
			callback();
		}
	}).observe(element);
}

export default function (element, onReveal) {
	// Once its top is a fifth of the screen up, not once a share of it shows: on phones the lists are taller than the screen, and would show empty first.
	new IntersectionObserver(([entry]) => {
		if (entry.isIntersecting && !element.classList.contains('in-view')) {
			element.classList.add('in-view');
			onReveal?.();
		}
	}, { rootMargin: '0px 0px -20% 0px' }).observe(element);

	whenBelow(element, () => element.classList.remove('in-view'));
}
